/****   request.js   ****/
// 导入axios
import axios from 'axios'
import config from '@/config/index';
import store from '@/store'
import { getToken } from '@/utils/auth'
import router from '@/router'
import { Toast } from 'vant'

const baseUrl =
  process.env.NODE_ENV === 'development'
    ? config.baseUrl.dev
    : config.baseUrl.pro;
//1. 创建新的axios实例，
const service = axios.create({
  // 公共接口--这里注意后面会讲
  baseURL:baseUrl,
  method: 'post',
  // 超时时间 单位是ms，这里设置了30s的超时时间
  timeout: 30 * 1000
})
// 2.请求拦截器
service.interceptors.request.use(config => {
    // 在发送请求之前
    if (store.getters.token) {
        // 每个请求携带token
        // ['QWToken'] 自定义请求头
        config.headers['FamousToken'] = getToken()
    }
    return config
}, error => {
  Promise.reject(error)
})

// 3.响应拦截器
service.interceptors.response.use(response => {
  //接收到响应数据并成功后的一些共有的处理，关闭loading等
    const res = response.data
    if (res.code !== '20000') {
        // 90003:非法令牌；90004:其他客户端已登录；90002:令牌已过期；
        if (res.code === '90003' || res.code === '90004' || res.code === '90002') {
            // console.info(res)
            router.replace('/')
        } else {
            if (res.code !== '30002') {
                Toast.fail(res.msg || 'Error')
            }
        }
        return Promise.reject(new Error(res.msg || 'Error'))
    } else {
        return res
    }
}, error => {
   /***** 接收到异常响应的处理开始 *****/
   console.log('err:' + error.code)
    Toast.fail(error.message)
  return Promise.reject(error)
})
//4.导入文件
export default service
